export const LIBRARY_TYPES = {
  EXERCISE: 'exercise',
  MATERIAL: 'education',
  QUESTIONNAIRE: 'questionnaire'
};
